import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { EmailTemplateGeneratorService } from 'src/app/services/email-template-generator.service';

@Component({
    selector: 'app-email-templates-dialog-new-template',
    templateUrl: './email-templates-dialog-new-template.component.html',
    styleUrls: ['./email-templates-dialog-new-template.component.scss'],
})
export class EmailTemplatesDialogNewTemplateComponent implements OnInit {

    public emailTemplateForm: FormGroup;
    public selectedTemplateType: number = 0; // 0 = Custom, 1 = TemplateA

    constructor(
        private formBuilder: FormBuilder,
        private emailTemplateGenerator: EmailTemplateGeneratorService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {

    }

    ngOnInit(): void {
        if (!this.data.hideName && !this.data.name) {
            this.data.name = '';
        }
        if (!this.data.subject) {
            this.data.subject = '';
        }
        if (!this.data.emailContentHtml) {
            this.data.emailContentHtml = '';
        }
        this.data.templateType = 0; // Default to Custom
        this.data.templateJSON = null;

        this.emailTemplateForm = this.formBuilder.group({
            name: [this.data.name],
            subject: [this.data.subject],
            email: [this.data.emailContentHtml],
            templateType: [this.selectedTemplateType]
        });
    }

    get submitButtonTitle() {
        return this.data.isUpdate
            ? 'Update Email Template'
            : 'Add Email Template';
    }

    /**
     * Handle template type selection change
     */
    onTemplateTypeChange(event: any): void {
        this.selectedTemplateType = event.value;
        this.data.templateType = this.selectedTemplateType;

        if (this.selectedTemplateType === 1) {
            // TemplateA selected - initialize with default JSON and generate initial HTML
            const defaultTemplateData = this.emailTemplateGenerator.getDefaultTemplateAJson();
            this.data.templateJSON = JSON.stringify(defaultTemplateData);
            this.data.emailContentHtml = this.emailTemplateGenerator.generateTemplateAHtml(defaultTemplateData);
        } else {
            // Custom template - clear templateJSON
            this.data.templateJSON = null;
            this.data.emailContentHtml = '';
        }
    }
}
